type Props = {
  title: string
  subtitle: string
}

export default function Header ({ title, subtitle }: Props) {
  return (
    <div className='flex flex-col gap-y-2'>
      <h1 className='heading-lg'>{title}</h1>
      <p className='body text-gray-500'>{subtitle}</p>
    </div>
  )
}
